export default {"src":"/_next/static/media/question_answering.13e6b5ea.svg","height":733,"width":583,"blurWidth":0,"blurHeight":0};